var map = {
	"./innovation-radar-data": [
		89039
	],
	"./innovation-radar-data.json": [
		89039
	],
	"./navigationStructure": [
		95409
	],
	"./navigationStructure.json": [
		95409
	],
	"./settings": [
		39727,
		727
	],
	"./settings.json": [
		39727,
		727
	],
	"./timeline": [
		7317
	],
	"./timeline.json": [
		7317
	],
	"./videoGallery": [
		27173,
		173
	],
	"./videoGallery.json": [
		27173,
		173
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 90487;
module.exports = webpackAsyncContext;